export const desktopCriteria = "(min-width:40rem)"
export const desktop = "@media " + desktopCriteria
